// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2pURR","gfeWrapper":"CalendarEvent_gfeWrapper__6iQ2T"};